import axios from 'axios';
import { auth } from '../config/firebase';

const baseURL = import.meta.env.VITE_REACT_APP_API_URL || 'https://api.socialness.ai';

export const api = axios.create({
  baseURL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add request interceptor to include auth token
api.interceptors.request.use(async (config) => {
  try {
    const token = await auth.currentUser?.getIdToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
  } catch (error) {
    console.error('Error getting Firebase token:', error);
  }
  return config;
});

// Add response interceptor to handle errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Handle unauthorized access
      console.error('Unauthorized access - redirecting to login');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

// Create Stripe portal session
export const createPortalSession = async (returnUrl: string = window.location.origin + '/billing') => {
  const response = await api.post('/stripe/create-portal-session', {
    returnUrl
  });
  return response.data;
}; 